import type { ImageUpload } from '../../api/chat';

/// Cạnh dài tối đa sau khi thu nhỏ — đủ nét để xem toàn màn, file thường 200–600KB.
const MAX_SIDE = 1600;
const JPEG_QUALITY = 0.82;

/**
 * Thu nhỏ + đổi sang JPEG ngay trong trình duyệt trước khi gửi: ảnh điện thoại 4–10MB
 * xuống vài trăm KB, và PNG/WebP/ảnh xoay EXIF đều ra một định dạng server chắc chắn nhận.
 * Ném lỗi nếu trình duyệt không đọc được file (vd HEIC trên Chrome).
 */
export async function prepareImage(file: Blob): Promise<ImageUpload> {
  // createImageBitmap mặc định xoay theo EXIF (imageOrientation: 'from-image').
  const bitmap = await createImageBitmap(file);
  const scale = Math.min(1, MAX_SIDE / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Trình duyệt không hỗ trợ canvas');
  // PNG trong suốt sang JPEG sẽ thành nền đen nếu không tô trắng trước.
  ctx.fillStyle = '#fff';
  ctx.fillRect(0, 0, width, height);
  ctx.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();

  const blob = await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', JPEG_QUALITY));
  if (!blob) throw new Error('Không nén được ảnh');
  return { blob, width, height };
}
